import { inject, Injectable } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { NotificationsController } from '@core/user-interface-legacy';

@Injectable({
  providedIn: 'root',
})
export class AutomationNotificationsService {
  private readonly notifications = inject(NotificationsController);
  private readonly i18n = inject(I18nService);

  public createAutomation(): void {
    this.notifications.success(
      this.i18n.translate('app.workflow_automations.notifications.create_success'),
    );
  }

  public updateAutomation(): void {
    this.notifications.success(
      this.i18n.translate('app.workflow_automations.notifications.update_success'),
    );
  }

  public updateAutomationFailure(): void {
    this.notifications.error({
      title: this.i18n.translate('app.workflow_automations.notifications.update_failure.title'),
      message: this.i18n.translate('app.workflow_automations.notifications.update_failure.message'),
    });
  }

  public deleteAutomation(): void {
    this.notifications.success(
      this.i18n.translate('app.workflow_automations.notifications.delete_success'),
    );
  }

  public duplicateAutomation(): void {
    this.notifications.success(
      this.i18n.translate('app.workflow_automations.notifications.duplicate_success'),
    );
  }
}
